<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon/300/mode auto">
      <mask id="mask0_15931_235542" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect id="Bounding box" width="24" height="24" fill="currentColor"/>
      </mask>
      <g mask="url(#mask0_15931_235542)">
        <path id="Vector" d="M6 17L11.1401 5H12.8599L18 17H16.174L14.773 13.5655H9.22705L7.82609 17H6ZM11.9227 6.93763L9.73913 12.2931H14.2609L12.0773 6.93763H11.9227Z" fill="currentColor"/>
        <path id="Vector_2" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor"/>
      </g>
    </g>
  </svg>
</template>